import { NormalizedNumber } from '@sparkdotfi/common-universal'
import { MoveRightIcon } from 'lucide-react'

import { Token } from '@/domain/types/Token'
import { HorizontalScroll } from '@/ui/atoms/horizontal-scroll/HorizontalScroll'
import { Info } from '@/ui/molecules/info/Info'
import { TokenAmount } from '@/ui/molecules/token-amount/TokenAmount'
import { testIds } from '@/ui/utils/testIds'

export interface TransactionOverviewSavingsBalanceChangeProps {
  token: Token
  amountBefore: NormalizedNumber
  amountAfter: NormalizedNumber
  amountAfterPrefix?: string
  infoText?: string
}

export function TransactionOverviewSavingsBalanceChange({
  token,
  amountBefore,
  amountAfter,
  amountAfterPrefix,
  infoText,
}: TransactionOverviewSavingsBalanceChangeProps) {
  return (
    <HorizontalScroll>
      <div className="flex items-center gap-2">
        <TokenAmount
          token={token}
          variant="horizontal"
          amount={amountBefore}
          showUsdAmount={false}
          amountDataTestId={testIds.dialog.savings.transactionOverview.balanceBefore}
        />
        <MoveRightIcon className="icon-size-xxs icon-secondary" />
        <div className="flex items-center gap-1">
          {amountAfterPrefix && <div className="typography-body-4 text-secondary">{amountAfterPrefix}</div>}
          <TokenAmount
            token={token}
            variant="horizontal"
            amount={amountAfter}
            showUsdAmount={false}
            amountDataTestId={testIds.dialog.savings.transactionOverview.balanceAfter}
          />
        </div>
        {infoText && <Info>{infoText}</Info>}
      </div>
    </HorizontalScroll>
  )
}
